import React from 'react';
export function TestimonialSection() {
  return <section className="mb-16" data-id="element-87">
      <h2 className="text-2xl font-bold text-teal-700 mb-6" data-id="element-88">
        Here's what other people are saying about it:
      </h2>
      <div className="space-y-6 mb-8" data-id="element-89">
        <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-90">
          <div className="flex items-center justify-between mb-4" data-id="element-91">
            <div className="flex items-center" data-id="element-92">
              <div className="w-12 h-12 rounded-full bg-peach-100 flex items-center justify-center text-xl font-semibold" data-id="element-93">
                EP
              </div>
              <div className="ml-4" data-id="element-94">
                <h3 className="font-semibold" data-id="element-95">Elle Perry</h3>
                <p className="text-gray-600" data-id="element-96">AU • 1 review</p>
              </div>
            </div>
            <div className="text-gray-600" data-id="element-97">Apr 30, 2025</div>
          </div>
          <div className="flex mb-2" data-id="element-98">
            {'★★★★★'.split('').map((star, i) => <span key={i} className="text-green-500" data-id="element-99">
                {star}
              </span>)}
          </div>
          <p className="text-lg font-medium mb-4" data-id="element-100">
            After struggling with anxiety and...
          </p>
          <p className="text-gray-700" data-id="element-101">
            After struggling with anxiety and burnout for years, the 30-Day
            Vagus Nerve Reset felt like a gentle way back to myself. I
            appreciated the short daily sessions—I never felt overwhelmed or
            like I was doing it "wrong." What stood out most was how calm I
            began to feel just a few days in. I wasn't expecting such a shift so
            soon.
          </p>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-102">
          <div className="flex items-center justify-between mb-4" data-id="element-103">
            <div className="flex items-center" data-id="element-104">
              <div className="w-12 h-12 rounded-full bg-peach-100 flex items-center justify-center text-xl font-semibold" data-id="element-105">
                JV
              </div>
              <div className="ml-4" data-id="element-106">
                <h3 className="font-semibold" data-id="element-107">Julia Vogt</h3>
                <p className="text-gray-600" data-id="element-108">DE • 1 review</p>
              </div>
            </div>
            <div className="text-gray-600" data-id="element-109">Apr 18, 2025</div>
          </div>
          <div className="flex mb-2" data-id="element-110">
            {'★★★★★'.split('').map((star, i) => <span key={i} className="text-green-500" data-id="element-111">
                {star}
              </span>)}
          </div>
          <p className="text-lg font-medium mb-4" data-id="element-112">
            Wasn't expecting much tbh but WOW
          </p>
          <p className="text-gray-700" data-id="element-113">
            Wasn't expecting much tbh but WOW. like actually wow. The way it's
            laid out is so easy to follow and not overwhelming which I NEED lol.
            first few days i was still kind of anxious but then something
            clicked. more grounded, less reactive, even my partner noticed. It's
            not magic but it kinda feels like it?
          </p>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-114">
          <div className="flex items-center justify-between mb-4" data-id="element-115">
            <div className="flex items-center" data-id="element-116">
              <div className="w-12 h-12 rounded-full bg-peach-100 flex items-center justify-center text-xl font-semibold" data-id="element-117">
                MP
              </div>
              <div className="ml-4" data-id="element-118">
                <h3 className="font-semibold" data-id="element-119">Mihaela Pavlic Lisac</h3>
                <p className="text-gray-600" data-id="element-120">HR • 4 reviews</p>
              </div>
            </div>
            <div className="text-gray-600" data-id="element-121">7 hours ago</div>
          </div>
          <div className="flex mb-2" data-id="element-122">
            {'★★★★★'.split('').map((star, i) => <span key={i} className="text-green-500" data-id="element-123">
                {star}
              </span>)}
          </div>
          <p className="text-lg font-medium mb-4" data-id="element-124">
            Kind and effective daily support from Neurotoned
          </p>
          <p className="text-gray-700" data-id="element-125">
            If you feel tired, stressed, anxious, burned out and demotivated to
            step out from this exhausted circle, these beautiful people from
            Neurotoned help you with simple but meaningful small steps.
            Breathing exercises, talk, and other somatic techniques to help you
            feel better. Nobody is pushing you, you can do it in your own pace.
            They are here for your every question and doubt, they give you daily
            support with kind words and advice. Couldn't recommend more ❤️.
          </p>
        </div>
      </div>
      <div className="text-center mb-8" data-id="element-126">
        <a href="https://www.trustpilot.com/review/neurotoned.com" className="inline-block bg-teal-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-teal-700 transition-colors" data-id="element-127">
          See More Reviews
        </a>
      </div>
      <p className="text-lg mb-6" data-id="element-128">
        If this resonates with you — if you've tried everything and the body
        symptoms still won't budge — you can learn exactly how{' '}
        <a href="https://www.neurotoned.com/41-off-neuro" className="text-teal-600 hover:text-teal-700" data-id="element-129">
          Neurotoned
        </a>{' '}
        works below.
      </p>
      <p className="text-lg mb-6" data-id="element-130">
        And right now,{' '}
        <a href="https://www.neurotoned.com/41-off-neuro" className="text-teal-600 hover:text-teal-700" data-id="element-131">
          this link is also the only place where you can save $41 off the full
          program price
        </a>{' '}
        — most people pay full to access it, but this discount is unlocked
        through this page only.
      </p>
      <p className="text-lg mb-6" data-id="element-132">
        If any of this resonates with you… I can't recommend{' '}
        <strong data-id="element-133">
          <a href="https://www.neurotoned.com/41-off-neuro" className="text-teal-600 hover:text-teal-700" data-id="element-134">
            this program
          </a>
        </strong>{' '}
        enough.
      </p>
    </section>;
}